import { useState } from 'react';
import { t } from '@lingui/macro';

import Pencil from '@decisiv/iconix/lib/components/Pencil';

import Button from '@decisiv/ui-components/lib/components/Button';

import type { ManagedFleet } from '../..';
import EditAccountModal from '../../EditAccountModal';

interface ActionCellProps {
  rowData: ManagedFleet;
}

const ActionsCell = ({ rowData: platformAccount }: ActionCellProps) => {
  const [modalVisible, setModalVisible] = useState(false);

  const handleActionClick = () => {
    setModalVisible(true);
  };

  return (
    <>
      <Button
        text={t`Edit`}
        icon={Pencil}
        kind="secondary"
        size="small"
        onClick={handleActionClick}
      />
      {modalVisible && (
        <EditAccountModal
          visible
          onClose={() => setModalVisible(false)}
          platformAccount={platformAccount}
        />
      )}
    </>
  );
};

export default ActionsCell;
